import '../vendor/lity'

const [ w, d ] = [ window, document ]

const init = () => {

  Promise.all( [ w.load['header'] ]).then( () => {
    $('.is--features header .p-gnav').currentMenu({mode: 0, default: 999});
  })

  if ($('.is--detail.is--article-4').length > 0) {
    $(window).on('scroll', function() {

      const windowHeight = $(window).height();

      const documentHeight = $(document).height();

      const scrollTop = $(window).scrollTop();

      // 下から64pxで発火
      const triggerPoint = documentHeight - windowHeight - 64;

      const classNameToAdd = 'scroll';

      const $targetElement = $('.p-pagetop__wrap_lp');

      if (scrollTop >= triggerPoint) {

        $targetElement.addClass(classNameToAdd);
      } else {

        $targetElement.removeClass(classNameToAdd);
      }
    });
  }

}

export default function FEATURES() {
  $( init )
}